<template>
    <div class="price-tooltip table">
        <button class="price-tooltip-close" @click="closeTolltip()">
            <svg class="close"><use xlink:href="#close"></use></svg>
        </button>

        <p class="info">Only show spots that I’ve saved to one of my lists.</p>
    </div>
</template>
<script>
export default {

    mounted() {
        $(document).on('click', '#on-my-list  .filter-info-popup-trigger', function () {
            $(this).toggleClass('active')
        })
    },

    methods: {
        closeTolltip() {
            $('#on-my-list  .filter-info-popup-trigger').removeClass('active')
        }
    }
}
</script>
